import InfoIcon from '@mui/icons-material/Info';
import {
  Box,
  Card,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useTranslate } from 'react-admin';
import { TotalPercentage } from '../../components/TotalPercentage';
import { customPalette } from '../../themes/customTheme';
import { InputText } from './InputText';

const useStyles = makeStyles({
  label: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '23px',
  },
  card: {
    padding: '12px 24px',
  },

  fields: {
    padding: '16px 8px !important',
    verticalAlign: 'top',
    borderBottom: '1px solid #EDEDED',
  },
});
export const Step2 = ({ step, control, register, watch, errors }) => {
  const teams_goals = watch('teams_goals');
  const classes = useStyles();
  const translate = useTranslate();
  if (step !== 2) return null;

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        marginBottom="8px"
        marginTop="32px"
      >
        <Typography className={classes.label}>
          Distribución por equipo
        </Typography>
      </Box>

      <Card className={classes.card}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left" width={'140px'}>
                  Equipo
                </TableCell>
                <TableCell align="left" sx={{ paddingLeft: '8px !important' }}>
                  Vistas
                </TableCell>
                <TableCell align="left" sx={{ paddingLeft: '8px !important' }}>
                  Notas
                </TableCell>
                <TableCell align="left" sx={{ paddingLeft: '8px !important' }}>
                  Calidad
                </TableCell>
                <TableCell align="left" sx={{ paddingLeft: '8px !important' }}>
                  Suscriptores
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ paddingLeft: '8px !important' }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {teams_goals?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    // borderBottom: '1px solid' + customPalette.greyStoke,
                  }}
                >
                  <TableCell
                    align="left"
                    sx={{
                      padding: '16px 8px !important',
                      borderBottom: '1px solid #EDEDED',
                    }}
                  >
                    <Typography>{`${row?.name}`}</Typography>
                  </TableCell>
                  <TableCell align="left" className={classes.fields}>
                    <InputText
                      variant="filled"
                      type="number"
                      control={control}
                      register={register}
                      name={`teams_goals[${index}].point_visits`}
                      label="Porcentaje"
                    />
                  </TableCell>
                  <TableCell align="left" className={classes.fields}>
                    <InputText
                      variant="filled"
                      type="number"
                      control={control}
                      register={register}
                      name={`teams_goals[${index}].point_notes`}
                      label="Porcentaje"
                    />
                  </TableCell>
                  <TableCell align="left" className={classes.fields}>
                    <InputText
                      variant="filled"
                      type="number"
                      control={control}
                      register={register}
                      name={`teams_goals[${index}].point_rfv`}
                      label="Porcentaje"
                    />
                  </TableCell>
                  <TableCell
                    align="left"
                    className={classes.fields}
                    sx={{ border: 0 }}
                  >
                    <InputText
                      variant="filled"
                      type="number"
                      control={control}
                      register={register}
                      name={`teams_goals[${index}].point_subscribers`}
                      label="Porcentaje"
                    />
                  </TableCell>

                  <TableCell
                    align="left"
                    className={classes.fields}
                    sx={{
                      width: '110px',
                    }}
                  >
                    <TotalPercentage
                      percentage={errors?.teams_goals}
                      totalPercentage={
                        Number(teams_goals[index]?.point_visits) +
                        Number(teams_goals[index]?.point_notes) +
                        Number(teams_goals[index]?.point_rfv) +
                        Number(teams_goals[index]?.point_subscribers)
                      }
                      errorMesage="resources.goals.validations.sumc100"
                      limitMessage="resources.goals.create.step1_error_limit"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            paddingTop: '16px',
          }}
        >
          <InfoIcon sx={{ color: customPalette.primary.main }} />
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '19px',
              color: customPalette.primary.main,
            }}
          >
            {translate('resources.goals.create.step1_limit')}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};
